import { useEffect, useState } from 'react';
import './Navbar.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faBox, faGift, faHeart, faUser, faWallet } from '@fortawesome/free-solid-svg-icons';
import SignUp from './user-management/SignUp';
import Login from './user-management/Login';
import ForgotPassword from './user-management/ForgotPassword';
import ResetPassword from './user-management/resetPassword';
import axios from 'axios';
import { FaPowerOff, FaUser } from 'react-icons/fa';

function Navbar() {

  const [user, setUser] = useState(null);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const location = useLocation();
  const orderId = location.state;
  const navigate = useNavigate();


  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('http://localhost:3001/auth/me', {
          withCredentials: true
        });
        setUser(response.data);
      } catch (error) {
        setUser(null);
      }
    };

    const verifyResetToken = async () => {
      const token = localStorage.getItem('resetToken');
      const userId = localStorage.getItem('resetUserId');

      if (token && userId) {
        try {
          const res = await axios.post('http://localhost:3001/verify-reset-token', {
            id: userId,
            token
          });
          if (res.data.valid) {
            setShowResetPassword(true);
          } else {
            clearResetTokens();
          }
        } catch (err) {
          console.error("Error verifying token:", err);
          clearResetTokens();
        }
      }
    };

    const clearResetTokens = () => {
      localStorage.removeItem('resetToken');
      localStorage.removeItem('resetUserId');
    };

    checkAuth();
    verifyResetToken();

    const showLoginListener = () => {
      setShowLogin(true);
      setShowSignUp(false);
      setShowForgotPassword(false);
      setShowResetPassword(false);
    };

    const showSignUpListener = () => {
      setShowSignUp(true);
      setShowLogin(false);
      setShowForgotPassword(false);
      setShowResetPassword(false);
    };

    const showForgotPasswordListener = () => {
      setShowForgotPassword(true);
      setShowLogin(false);
      setShowSignUp(false);
      setShowResetPassword(false);
    }

    window.addEventListener("showLoginModal", showLoginListener);
    window.addEventListener("showSignUpModal", showSignUpListener);
    window.addEventListener("showForgotPassword", showForgotPasswordListener);

    return () => {
      window.removeEventListener("showLoginModal", showLoginListener);
      window.removeEventListener("showSignUpModal", showSignUpListener);
      window.removeEventListener("showForgotPassword", showForgotPasswordListener);
    }
  })

  const handleLogout = async () => {
    try {
      await axios.post('http://localhost:3001/logout', {}, {
        withCredentials: true
      });
      setUser(null);
      // window.location.href = '/home';
      navigate('/home');
    } catch (error) {
      console.error("Logout error:", error);
    }
  }

  const handleTrackOrderClick = (e) => {
    e.preventDefault();
    if (user) {
      navigate('/track-order');
    } else {
      setShowLogin(true);
    }
  };


  const commonMenuItems = (
    <>
      <li>
        <Link className="dropdown-item" to="/my-account">
          <FontAwesomeIcon icon={faUser} className="me-2" />
          My Account
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/track-order">
          <FontAwesomeIcon icon={faBox} className="me-2" />
          Order History
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/wishlist">
          <FontAwesomeIcon icon={faHeart} className="me-2" />
          My Wishlist
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/alerts">
          <FontAwesomeIcon icon={faBell} className="me-2" />
          Alerts & Coupons
        </Link>
      </li>
      <li>
        <Link 
        className="dropdown-item" 
        to="/my-account" 
        state={{activeTab: 'giftCard'}}
        >
          <FontAwesomeIcon icon={faGift} className="me-2" />
          Gift Cards
        </Link>
      </li>
      <li>
        <Link 
        className="dropdown-item" 
        to="/my-account" 
        state={{activeTab: 'cliqCash'}}
        >
          <FontAwesomeIcon icon={faWallet} className="me-2" />
          CLiQ Cash
        </Link>
      </li>
    </>
  );

  return (
    <>
      <div className="navbar-container">
        <div className="navbar-red-gap"></div>
        <nav className="navbar navbar-expand-lg navbar-dark">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/home">
              Tata CLiQ Luxury
            </Link>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse justify-content-end" id="navbarContent">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link 
                  className="nav-link" 
                  to="/my-account" 
                  state={{activeTab: 'cliqCash'}}
                  // onClick={(e) => { e.preventDefault(); setShowSignUp(true); }}
                  >
                    CLiQ Cash
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                  className="nav-link" 
                  to="/my-account" 
                  state={{activeTab: 'giftCard'}}
                  // onClick={(e) => { e.preventDefault(); setShowSignUp(true); }}
                  >
                    Gift Card
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="">CLiQ Care</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/track-order"
                    onClick={(e) => {
                      e.preventDefault();
                      if (user) {
                        navigate('/track-order');
                      } else {
                        setShowLogin(true);
                      }
                    }
                    }
                  >Track Orders</Link>
                </li>

                <li className="nav-item dropdown hover-dropdown">
                  {user ? (
                    <>
                      <Link className="nav-link" to="#" role="button" data-bs-toggle="dropdown">
                        {user.name}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end">
                         {commonMenuItems}
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <Link className="dropdown-item" to="#" onClick={handleLogout}>
                            <FaPowerOff className="me-2" />
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </>
                  ) : (
                    <>
                      <Link className="nav-link" to="#" role="button" data-bs-toggle="dropdown">
                        Sign in / Sign Up
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                          <Link className='dropdown-item loginRegister' to="#"
                            onClick={(e) => { e.preventDefault(); setShowSignUp(true); }}
                          >
                            Login/Register
                          </Link>
                        </li>
                        {commonMenuItems}
                      </ul>
                    </>
                  )}

                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>


      {/* <AuthModel show={showModal} onClose={() => setShowModal(false)} /> */}
      <SignUp show={showSignUp}
        onClose={() => {
          setShowSignUp(false);
          setShowLogin(false);
          setShowForgotPassword(false);
        }}
        onSwitchToLogin={() => {
          setShowSignUp(false);
          setShowLogin(true);
          setShowForgotPassword(false);
        }}
      />
      <Login show={showLogin}
        onClose={() => {
          setShowLogin(false);
          setShowSignUp(false);
          setShowForgotPassword(false);
        }}
        onSwitchToSignUp={() => {
          setShowLogin(false);
          setShowSignUp(true);
          setShowForgotPassword(false);
        }}
        onSwitchToForgotPassword={() => {
          setShowLogin(false);
          setShowSignUp(false);
          setShowForgotPassword(true);
        }}
      />
      <ForgotPassword show={showForgotPassword}
        onClose={() => {
          setShowForgotPassword(false);
          setShowLogin(false);
          setShowSignUp(false);
        }}
        onSuccess={() => {
          // setShowSignUp(false);
          // setShowLogin(false);
          setShowForgotPassword(false);
          // setShowResetPassword(true);
          alert("Password reset link has been sent to your email");
        }}
      />
      <ResetPassword show={showResetPassword}
        onClose={() => {
          // setShowForgotPassword(false);
          // setShowLogin(false);
          // setShowSignUp(false);
          setShowResetPassword(false);
          localStorage.removeItem('resetToken');
          localStorage.removeItem('resetUserId');
        }}
        onSwitchToLogin={() => {
          setShowResetPassword(false);
          setShowLogin(true);
          localStorage.removeItem('resetToken');
          localStorage.removeItem('resetUserId');
        }}
      />
    </>
  );
}

export default Navbar;
